import Avatar from './ant';

export default Avatar;
